import { Drawer as MantineDrawer } from '@mantine/core';

export default function Drawer(props){
    const {open, closeDrawer, children} = props
    return (
      <MantineDrawer
      opened={open}
      position={'right'}
      size="300px"
      overlayOpacity={0.5}
      zIndex={1000000}
      onClose={()=> closeDrawer()}
      withCloseButton={false}
      >
        {children}
      </MantineDrawer>
    )
  }